// Feature Toggle Keys - Matching Flutter implementation
// Source: centrajob_frontend_college/lib/utils/services/feature_toggle/feature_toggle_key.dart

// ==================== Feature Toggle Keys ====================
// All feature toggles are boolean values from Firebase Remote Config

export const FeatureToggleKeys = {
  // Legacy Features
  enableGetAllCandidates: 'enableGetAllCandidates',
  enableCollegeJobsView: 'enableCollegeJobsView',
  enableCollegeManageCandidatesView: 'enableCollegeManageCandidatesView',
  enableCollegeCourseManagementView: 'enableCollegeCourseManagementView',
  enableUploadCollegeLogo: 'enableUploadCollegeLogo',
  enableCollegeStudentRequestsTab: 'enableCollegeStudentRequestsTab',
  enableCollegeNotifications: 'enableCollegeNotifications',
  enableCollegeOrTpoSettings: 'enableCollegeOrTpoSettings',

  // V2 Core Features
  enableV2AddCourse: 'enableV2AddCourse',
  enableV2ManageJobs: 'enableV2ManageJobs',
  enableV2ManageCourse: 'enableV2ManageCourse',
  enableV2ReportsAndAnalytics: 'enableV2ReportsAndAnalytics',
  enableV2HeaderActionButton: 'enableV2HeaderActionButton',

  // V2 Profile Settings
  enableV2ProfileSettings: 'enableV2ProfileSettings',
  enableV2TPOSettings: 'enableV2TPOSettings',
  enableV2ProfileSettingsPersonalInfo: 'enableV2ProfileSettingsPersonalInfo',
  enableV2ProfileSettingsCollegeDetails: 'enableV2ProfileSettingsCollegeDetails',
  enableV2ProfileSettingsKYC: 'enableV2ProfileSettingsKYC',
  enableV2ProfileSettingsPassword: 'enableV2ProfileSettingsPassword',
  enableV2ProfileSettingsTeam: 'enableV2ProfileSettingsTeam',
  enableV2ProfileSettingsNotification: 'enableV2ProfileSettingsNotification',
  enableV2ProfileSettingsHelp: 'enableV2ProfileSettingsHelp',
  enableV2ProfileSettingsManageStageTracking: 'enableV2ProfileSettingsManageStageTracking',

  // V2 Manage Candidates Features
  enableV2ManageCandidateFilter: 'enableV2ManageCandidateFilter',
  enableV2ManageCandidateInviteCandidate: 'enableV2ManageCandidateInviteCandidate',
  enableV2ManageCandidateMoreButton: 'enableV2ManageCandidateMoreButton',
  enableV2ManageCandidateSearch: 'enableV2ManageCandidateSearch',
  enableManageCandidateStageTracking: 'enableManageCandidateStageTracking',
  enableManageCandidatesConsultationCall: 'enableManageCandidatesConsultationCall',
  enableManageCandidateGridView: 'enableManageCandidateGridView',
  enableCandidateBatchLevelTracker: 'enableCandidateBatchLevelTracker',
  enableV2ManageCandidateSingleInviteCandidate: 'enableV2ManageCandidateSingleInviteCandidate',
  enableV2ManageCandidateBulkInviteCandidate: 'enableV2ManageCandidateBulkInviteCandidate',
  enableV2ManageCandidateInviteCandidateTab: 'enableV2ManageCandidateInviteCandidateTab',

  // V2 Manage Jobs Features
  enableV2ManageJobSearch: 'enableV2ManageJobSearch',
  enableV2CheckBoxSelectionManageJobs: 'enableV2CheckBoxSelectionManageJobs',
  enablev2JobTitlesFilterDropdownManageJobs: 'enablev2JobTitlesFilterDropdownManageJobs',
  enableV2ManageJobsShare: 'enableV2ManageJobsShare',
  enableV2ManageJobsComment: 'enableV2ManageJobsComment',
  enableV2ManageJobView: 'enableV2ManageJobView',
  enableV2ManageJobsViewIcon: 'enableV2ManageJobsViewIcon',
  enablev2JLocationFilterDropdownManageJobs: 'enablev2JLocationFilterDropdownManageJobs',
  enableManageJobApplicationTab: 'enableManageJobApplicationTab',
  enableManageJobGridView: 'enableManageJobGridView',
  enableManageApplicationGridView: 'enableManageApplicationGridView',

  // V2 Dashboard Features
  enableV2DashboardDiscoverJobButton: 'enableV2DashboardDiscoverJobButton',
  enableV2DashboardInviteTeamMembersButton: 'enableV2DashboardInviteTeamMembersButton',

  // V2 Manage Course Features
  enableV2ManageCourseDepartmentFilter: 'enableV2ManageCourseDepartmentFilter',
  enableV2ManageCourseEditCourse: 'enableV2ManageCourseEditCourse',
  enableV2ManageCourseShareCourse: 'enableV2ManageCourseShareCourse',
  enableV2ManageCourseDeleteCourse: 'enableV2ManageCourseDeleteCourse',
  enableV2ManageCourseDashboardListIcon: 'enableV2ManageCourseDashboardListIcon',
  enableV2ManageCourseDashboardTableIcon: 'enableV2ManageCourseDashboardTableIcon',
  enableV2ManageourseFilterColumn: 'enableV2ManageourseFilterColumn',
  enableV2ManageCourseSearchFunctionality: 'enableV2ManageCourseSearchFunctionality',

  // Other V2 Features
  enableV2Announcements: 'enableV2Announcements',
  enableSemantics: 'enableSemantics',
  enableLearningModule: 'enableLearningModule',
  enableLearningTrainingPortal: 'enableLearningTrainingPortal',
  enableBatchTrainingPortal: 'enableBatchTrainingPortal',
  enableCreateStageButton: 'enableCreateStageButton',
  enableAddParameterButton: 'enableAddParameterButton',
  enableEventsCalendar: 'enableEventsCalendar',
  enableChatbot: 'enableChatbot',
  enableCandidateJobApplicationToggleForCollege: 'enableCandidateJobApplicationToggleForCollege',
  enableShareWhatsappMessageButton: 'enableShareWhatsappMessageButton',
  enableAddCandidateForJobApplication: 'enableAddCandidateForJobApplication',
  enableImportCandidateExcelForJobApplication: 'enableImportCandidateExcelForJobApplication',
} as const;

// ==================== Type Definitions ====================
export type FeatureToggleKeyType = typeof FeatureToggleKeys[keyof typeof FeatureToggleKeys];

// ==================== Default Values ====================
// Default values for feature toggles (matching Flutter implementation)
export const FeatureToggleDefaults: Record<FeatureToggleKeyType, boolean> = {
  // Legacy Features - default false
  [FeatureToggleKeys.enableGetAllCandidates]: false,
  [FeatureToggleKeys.enableCollegeJobsView]: false,
  [FeatureToggleKeys.enableCollegeManageCandidatesView]: false,
  [FeatureToggleKeys.enableCollegeCourseManagementView]: false,
  [FeatureToggleKeys.enableUploadCollegeLogo]: false,
  [FeatureToggleKeys.enableCollegeStudentRequestsTab]: false,
  [FeatureToggleKeys.enableCollegeNotifications]: false,
  [FeatureToggleKeys.enableCollegeOrTpoSettings]: false,

  // V2 Core Features - default false
  [FeatureToggleKeys.enableV2AddCourse]: false,
  [FeatureToggleKeys.enableV2ManageJobs]: false,
  [FeatureToggleKeys.enableV2ManageCourse]: false,
  [FeatureToggleKeys.enableV2ReportsAndAnalytics]: false,
  [FeatureToggleKeys.enableV2HeaderActionButton]: false,

  // V2 Profile Settings - default true (enabled by default)
  [FeatureToggleKeys.enableV2ProfileSettings]: true,
  [FeatureToggleKeys.enableV2TPOSettings]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsPersonalInfo]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsCollegeDetails]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsKYC]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsPassword]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsTeam]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsNotification]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsHelp]: true,
  [FeatureToggleKeys.enableV2ProfileSettingsManageStageTracking]: true,

  // V2 Manage Candidates Features - default false
  [FeatureToggleKeys.enableV2ManageCandidateFilter]: false,
  [FeatureToggleKeys.enableV2ManageCandidateInviteCandidate]: false,
  [FeatureToggleKeys.enableV2ManageCandidateMoreButton]: false,
  [FeatureToggleKeys.enableV2ManageCandidateSearch]: false,
  [FeatureToggleKeys.enableManageCandidateStageTracking]: false,
  [FeatureToggleKeys.enableManageCandidatesConsultationCall]: false,
  [FeatureToggleKeys.enableManageCandidateGridView]: false,
  [FeatureToggleKeys.enableCandidateBatchLevelTracker]: false,
  [FeatureToggleKeys.enableV2ManageCandidateSingleInviteCandidate]: false,
  [FeatureToggleKeys.enableV2ManageCandidateBulkInviteCandidate]: false,
  [FeatureToggleKeys.enableV2ManageCandidateInviteCandidateTab]: false,

  // V2 Manage Jobs Features - default false
  [FeatureToggleKeys.enableV2ManageJobSearch]: false,
  [FeatureToggleKeys.enableV2CheckBoxSelectionManageJobs]: false,
  [FeatureToggleKeys.enablev2JobTitlesFilterDropdownManageJobs]: false,
  [FeatureToggleKeys.enableV2ManageJobsShare]: false,
  [FeatureToggleKeys.enableV2ManageJobsComment]: false,
  [FeatureToggleKeys.enableV2ManageJobView]: false,
  [FeatureToggleKeys.enableV2ManageJobsViewIcon]: false,
  [FeatureToggleKeys.enablev2JLocationFilterDropdownManageJobs]: false,
  [FeatureToggleKeys.enableManageJobApplicationTab]: false,
  [FeatureToggleKeys.enableManageJobGridView]: false,
  [FeatureToggleKeys.enableManageApplicationGridView]: false,

  // V2 Dashboard Features - default false
  [FeatureToggleKeys.enableV2DashboardDiscoverJobButton]: false,
  [FeatureToggleKeys.enableV2DashboardInviteTeamMembersButton]: false,

  // V2 Manage Course Features - default false
  [FeatureToggleKeys.enableV2ManageCourseDepartmentFilter]: false,
  [FeatureToggleKeys.enableV2ManageCourseEditCourse]: false,
  [FeatureToggleKeys.enableV2ManageCourseShareCourse]: false,
  [FeatureToggleKeys.enableV2ManageCourseDeleteCourse]: false,
  [FeatureToggleKeys.enableV2ManageCourseDashboardListIcon]: false,
  [FeatureToggleKeys.enableV2ManageCourseDashboardTableIcon]: false,
  [FeatureToggleKeys.enableV2ManageourseFilterColumn]: false,
  [FeatureToggleKeys.enableV2ManageCourseSearchFunctionality]: false,

  // Other V2 Features - default false
  [FeatureToggleKeys.enableV2Announcements]: false,
  [FeatureToggleKeys.enableSemantics]: false,
  [FeatureToggleKeys.enableLearningModule]: false,
  [FeatureToggleKeys.enableLearningTrainingPortal]: false,
  [FeatureToggleKeys.enableBatchTrainingPortal]: false,
  [FeatureToggleKeys.enableCreateStageButton]: false,
  [FeatureToggleKeys.enableAddParameterButton]: false,
  [FeatureToggleKeys.enableEventsCalendar]: false,
  [FeatureToggleKeys.enableChatbot]: false,
  [FeatureToggleKeys.enableCandidateJobApplicationToggleForCollege]: false,
  [FeatureToggleKeys.enableShareWhatsappMessageButton]: false,
  [FeatureToggleKeys.enableAddCandidateForJobApplication]: true,
  [FeatureToggleKeys.enableImportCandidateExcelForJobApplication]: false,
};

// ==================== Feature Groups ====================
// Grouped keys for easier management

export const ProfileSettingsFeatures = [
  FeatureToggleKeys.enableV2ProfileSettings,
  FeatureToggleKeys.enableV2TPOSettings,
  FeatureToggleKeys.enableV2ProfileSettingsPersonalInfo,
  FeatureToggleKeys.enableV2ProfileSettingsCollegeDetails,
  FeatureToggleKeys.enableV2ProfileSettingsKYC,
  FeatureToggleKeys.enableV2ProfileSettingsPassword,
  FeatureToggleKeys.enableV2ProfileSettingsTeam,
  FeatureToggleKeys.enableV2ProfileSettingsNotification,
  FeatureToggleKeys.enableV2ProfileSettingsHelp,
  FeatureToggleKeys.enableV2ProfileSettingsManageStageTracking,
] as const;

export const ManageCandidatesFeatures = [
  FeatureToggleKeys.enableV2ManageCandidateFilter,
  FeatureToggleKeys.enableV2ManageCandidateInviteCandidate,
  FeatureToggleKeys.enableV2ManageCandidateMoreButton,
  FeatureToggleKeys.enableV2ManageCandidateSearch,
  FeatureToggleKeys.enableManageCandidateStageTracking,
  FeatureToggleKeys.enableManageCandidatesConsultationCall,
  FeatureToggleKeys.enableManageCandidateGridView,
  FeatureToggleKeys.enableCandidateBatchLevelTracker,
] as const;

export const ManageJobsFeatures = [
  FeatureToggleKeys.enableV2ManageJobs,
  FeatureToggleKeys.enableV2ManageJobSearch,
  FeatureToggleKeys.enableV2CheckBoxSelectionManageJobs,
  FeatureToggleKeys.enablev2JobTitlesFilterDropdownManageJobs,
  FeatureToggleKeys.enableV2ManageJobsShare,
  FeatureToggleKeys.enableV2ManageJobsComment,
  FeatureToggleKeys.enableV2ManageJobView,
  FeatureToggleKeys.enableV2ManageJobsViewIcon,
  FeatureToggleKeys.enablev2JLocationFilterDropdownManageJobs,
  FeatureToggleKeys.enableManageJobApplicationTab,
  FeatureToggleKeys.enableManageJobGridView,
  FeatureToggleKeys.enableManageApplicationGridView,
] as const;

export const ManageCourseFeatures = [
  FeatureToggleKeys.enableV2ManageCourse,
  FeatureToggleKeys.enableV2AddCourse,
  FeatureToggleKeys.enableV2ManageCourseDepartmentFilter,
  FeatureToggleKeys.enableV2ManageCourseEditCourse,
  FeatureToggleKeys.enableV2ManageCourseShareCourse,
  FeatureToggleKeys.enableV2ManageCourseDeleteCourse,
  FeatureToggleKeys.enableV2ManageCourseDashboardListIcon,
  FeatureToggleKeys.enableV2ManageCourseDashboardTableIcon,
  FeatureToggleKeys.enableV2ManageourseFilterColumn,
  FeatureToggleKeys.enableV2ManageCourseSearchFunctionality,
] as const;

export const DashboardFeatures = [
  FeatureToggleKeys.enableV2DashboardDiscoverJobButton,
  FeatureToggleKeys.enableV2DashboardInviteTeamMembersButton,
] as const;

// ==================== Helper Functions ====================
export const isFeatureToggleKey = (key: string): key is FeatureToggleKeyType => {
  return Object.values(FeatureToggleKeys).includes(key as FeatureToggleKeyType);
};

export const getDefaultValue = (key: FeatureToggleKeyType): boolean => {
  return FeatureToggleDefaults[key] ?? false;
};
